import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-3"
}
const _hoisted_2 = { class: "box has-background-dark has-text-centered" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "has-text-white" }, "Game ID", -1)
const _hoisted_4 = { class: "title has-text-white has-text-weight-bold" }
const _hoisted_5 = { class: "box" }
const _hoisted_6 = { class: "column is-10" }
const _hoisted_7 = { class: "mr-1 has-text-weight-bold" }
const _hoisted_8 = {
  key: 0,
  class: "tag is-black"
}
const _hoisted_9 = {
  key: 0,
  class: "column"
}
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("span", { class: "has-text-weight-bold" }, " Start game!", -1)
const _hoisted_13 = [
  _hoisted_12
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.gameData)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$route.params.gameId), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.gameData.players, (player) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "columns is-mobile",
              key: player.pid
            }, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("span", _hoisted_7, _toDisplayString(player.name), 1),
                (_ctx.isOwner(player.pid))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, "Owner"))
                  : _createCommentVNode("", true)
              ]),
              (
            _ctx.playerId == _ctx.gameData.createdBy && player.pid != _ctx.gameData.createdBy
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("button", {
                      class: "delete is-medium",
                      onClick: ($event: any) => (_ctx.removePlayer(player))
                    }, null, 8, _hoisted_10)
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ]),
        (_ctx.gameData.createdBy == _ctx.playerId)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "button is-black is-fullwidth",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.assignRoles && _ctx.assignRoles(...args))),
              disabled: _ctx.gameData.players.length < 7 || _ctx.gameData.players.length > 10
            }, _hoisted_13, 8, _hoisted_11))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}